export default "__VITE_ASSET__BzH3Jj72__"